import styles from './QrCode.module.css';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { Button } from '../Button/Button';
import { Card } from '../Card/Card';
import { InlineNotification } from '../InlineNotification/InlineNotification';

interface QrCodeProps {
  data: string;
  onCancel: () => void;
  socketErrorCode?: string;
}

export const QrCode = ({ data, onCancel, socketErrorCode  }: QrCodeProps) => {
  return (
    <div className={styles.cardContainer}>
      <Card>
        <Stack
          className={styles.codeContainer}
          direction="column"
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          <Stack
            className={styles.codeContainerInner}
            {...{ 'aria-live': 'polite', tabIndex: 0 }}
            sx={{
              alignItems: 'center',
              gap: 1
            }}>
            <Typography
              component="p"
              {...{ 'data-testid': 'qrCodeTitle' }}
              sx={{
                textAlign: 'center'
              }}>
              {t('form.sid.DeviceLink.QrDescription')}
            </Typography>

            {socketErrorCode && socketErrorCode !== 'INTERNAL_ERROR' && (
                <InlineNotification appearance="error">
                  <span>{t(`form.socketError.${socketErrorCode}.text`)}</span>
                </InlineNotification>
            )}

            <Box sx={{
              my: 2
            }}>
              {data ? (
                  <img
                      src={data}
                      alt={t('form.qrCode.altText')}
                      {...{ 'data-testid': 'qrCodeImage' }}
                  />
              ) : (
                  <CircularProgress
                      aria-label="Spinner"
                      size={80}
                      color="primary"
                      {...{ 'data-testid': 'qrCodeSpinner' }}
                  />
                )
              }
            </Box>
          </Stack>

          <Button
            appearance="text"
            size="m"
            color="outline"
            onClick={onCancel}
            {...{ 'data-testid': 'qrCodeCodeCancel' }}
          >
            {t('form.general.back')}
          </Button>
        </Stack>
      </Card>
    </div>
  );
};
